import loadable from "@loadable/component";
import { isFeedResult, isItemBlock, isPublishRecord } from "../../../../core/lib/guards";
import { logger } from "../../../../core/lib/logging";
import { PageBlockInterface } from "../../../../core/page-blocks/Block.component";

const CoastPreviousNextLoader = loadable(() => import("./CoastPreviousNextLoader.component"));

const log = logger.getChild("CoastItemReference.component");

const CoastItemReference = ({ block }: PageBlockInterface) => {
    if (!isItemBlock(block)) {
        log.error("No item on block", block);
        return null;
    }

    if (isFeedResult(block.item?.result)) {
        const content = block.item?.result.record;

        if (block.tags?.includes("display-hints/previous-next") && isPublishRecord(content)) {
            return <CoastPreviousNextLoader block={block} content={content} />;
        }
    }

    return null;
};

export default CoastItemReference;
